import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Dialogmessage from '../../dialog';
import Loading from '../../loading';

class Edit extends Component {

  state={
    load: false, message: '', error: '',
    dialogstatus: false, tax: '', from_serialno: '',
    to_serialno: '', hsn_code: '', movementOption: '',
  }

  componentDidMount() {
    this.setValuesToState(this.props);
    this.setMovements();
  }

  componentWillReceiveProps(props) {
      this.setValuesToState(props);
      this.setMovements();
  }

  setValuesToState(props) {
    let data = props.data;
    this.setState({ tax: data.tax, oldtax: data.tax, from_serialno: data.from_serialno,
      to_serialno: data.to_serialno, hsn_code: data.hsn_code,
      movement: data.movement,
    })
  }

  updateChar() {
    let context = this;
    let partno = this.props.partno;
    if(!this.state.tax) { alert('Enter tax field!!!'); return; }
    if(!this.state.from_serialno) { alert('Enter From serial number field!!!'); return; }
    if(!this.state.to_serialno) { alert('Enter to serial number field!!!'); return; }
    if(!this.state.hsn_code) { alert('Enter code field!!!'); return; }
    if(!this.state.movement) { alert('Select Movement field!!!'); return; }
    context.setState({ load: true, message: 'Spare Characteristics Editing!!!' });
    let data1 = { 'partno': this.props.partno, 'tax': this.state.tax,
                  'from_serialno': this.state.from_serialno, 'hsn_code': this.state.hsn_code,
                  'oldtax': this.state.oldtax,
                  'to_serialno': this.state.to_serialno, 'movement': this.state.movement };
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'spares/updatecharacteristics.php',
      success: function(data) {
        console.log(data);
        if (data == 1) {
          context.setState({ load: false, dialogmessage: 'Characteristics Edited successfully!!!',
                             dialogstatus: true });
        }
        else {
          context.setState({ load: false });
          alert('Try again');
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  closedialog() { this.setState({ dialogstatus: false }) }

  onChange = (type) => (e, {value}) => { this.setState({ [type]: value }) }

  setMovements() {
    let context = this;
    var x = [];
    let menu = ['Very Fast', 'Fast', 'Avarage', 'Slow'];
    menu.map((y) => { x.push({key: y, text: y, value: y}); });
    try {
      context.setState({ movementOption: x });
    } catch (e) {}
  }

  render() {
    let { load, message, dialogmessage, dialogstatus, movement } = this.state;
    let loading, dialogs;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (dialogstatus) {
      dialogs = (<Dialogmessage message={dialogmessage} closedialog={this.closedialog.bind(this)} dialogstatus={dialogstatus} />)
    }
    let x = (
        <div>
        <Card fluid>
          <Grid style={{padding: '1%'}}>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              Tax<br/>
              <Input type="number" id='tax' value={this.state.tax} focus placeholder='Tax'
              onChange={this.onChange('tax')} style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              From-Serial-No<br/>
              <Input type="number" id='from_serial_no' onChange={this.onChange('from_serialno')}
              value={this.state.from_serialno} focus placeholder='From-Serial-No'
              style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              To-Serial-No<br/>
              <Input type="number" id='to_serial_no' onChange={this.onChange('to_serialno')}
              value={this.state.to_serialno} focus placeholder='To-Serial-No'
              style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              HSN-CODE<br/>
              <Input type="number" id='code' value={this.state.hsn_code}
              onChange={this.onChange('hsn_code')} focus placeholder='HSN-CODE'
              style={{ borderColor: '#5A9CBB' }} fluid />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              Movement<br/>
              <Dropdown fluid
                id="Movement" onChange={this.onChange('movement')} placeholder='Select Movement'
                search selection options={this.state.movementOption}
                value={movement} fluid style={{ borderColor: '#5A9CBB' }} />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <center><div style={{color: 'red', fontSize: 13, fontWeight: 'bold'}}>{this.state.error}</div></center>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <Button fluid positive onClick={this.updateChar.bind(this)}>Save</Button>
            </Grid.Column>
          </Grid>
        </Card>
        </div>
      );
    return (
      <div style={{padding: '1%'}}>
        {x}
        {loading}
        {dialogs}
      </div>
    );
  }
}

export default Edit;
